function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1190 130.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M462.78,1.83V128.28H439.69L402.86,64.51v63.77H374.27V1.83h22.91l37,64.69V1.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.27,1.83l14.11,42.34L529.49,1.83h33.72L530.59,79.9v48.38H500.17V79.9L467.55,1.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.38,128.28,583.66,1.83h30.06L650,128.28H618.11l-4.76-21.62h-29.5l-4.77,21.62ZM591,81.37h15l-7.33-36.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.63,1.83V128.28H718.54L681.71,64.51v63.77H653.12V1.83H676l37,64.69V1.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31,128.28H22.36L0,1.83H33.17l8.43,70,17-70H85l17,70,8.61-70h33L121.32,128.28h-29L71.84,52.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,128.28,174.63,1.83h30.05L241,128.28H209.08l-4.77-21.62h-29.5l-4.76,21.62ZM182,81.37h15l-7.33-36.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,1.83V128.28H309.51L272.67,64.51v63.77H244.08V1.83H267l37,64.69V1.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.71,128.28h-29L771.4,1.83h33.17l8.43,70,17-70h26.39l17.05,70,8.61-70h33L892.72,128.28h-29L843.24,52.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.74,128.28,946,1.83h30.05l36.29,126.45H980.48l-4.76-21.62H946.21l-4.76,21.62Zm43.62-46.91h15l-7.33-36.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071,128.28l-16.31-47.83h-9.17v47.83h-30.42V1.83h42.52c24.74,0,41.6,13.38,41.6,39.77,0,16.49-6.23,27.49-15.76,33.17l19.79,53.51Zm-18.33-73.12c8.61,0,16.13-1.65,16.13-13.56,0-12.1-7.52-14.48-16.13-14.48h-7.15v28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.83,36.84c-3.85-8.43-9-11.55-16.31-11.55-7.7,0-10.63,4.58-10.63,11,0,7.51,4.21,11,17,15.76,23.82,8.79,32.07,18.69,32.07,40.31,0,22.91-14.48,37.76-38.48,37.76-20,0-33.36-5.69-44-20.71l21.26-16c5,7.88,11.55,11.36,18.69,11.36,9.17,0,12.1-4.94,12.1-11,0-7.33-3.12-10.63-18.14-16.49-22-8.44-31-20.53-31-40.87,0-20.89,12.64-36.47,39.21-36.47,17,0,31.71,6.78,39.22,20.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fc267781.svg";
export { ForwardRef as ReactComponent };